import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { APP_CONFIG } from '@/constants';
import { cn } from '@/utils/cn';

interface LoadingPageProps {
  message?: string;
  fullScreen?: boolean;
  showLogo?: boolean;
}

export function LoadingPage({ message, fullScreen = true, showLogo = true }: LoadingPageProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center bg-background',
        fullScreen ? 'min-h-screen' : 'h-full min-h-[200px]'
      )}
    >
      {showLogo && (
        <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-xl bg-primary text-primary-foreground text-2xl font-bold shadow-lg">
          YMS
        </div>
      )}

      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground animate-pulse">
          {message ?? t('common.loading')}
        </p>
      </div>

      {showLogo && <p className="mt-8 text-xs text-muted-foreground">{APP_CONFIG.fullName}</p>}
    </div>
  );
}

// Inline spinner for use within components
interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  return <Loader2 className={cn('animate-spin text-primary', sizeClasses[size], className)} />;
}
